import React from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}
export default function Basic(props) {
    let userAttributes = [];
    let i = 0;
    let columns = [];
    let rows = [];
    if (
     props.deviceData !== undefined
        // &&
        // props.venueListUtilization !== undefined
    ) {
        // console.log(props.unitData)
        for (const key of Object.keys(props.deviceData)) {
            //  if (
            //   props.venueListUtilization[props.venueList[key]["VenueID"]] !==
            //   undefined
            // ) {
            if (props.deviceData !== undefined) {
                userAttributes.push({
                id: key,
                status:
                    props.deviceData[key]["currentlyOnline"],
                type: props.deviceData[key]["DeviceType"],
                deviceName: props.deviceData[key]["UserDefinedHostName"],
                hostName: props.deviceData[key]["HostName"],
                ipaddress: props.deviceData[key]["Framed-IP-Address"],
                lastConnected:
                    props.deviceData[key]["mostRecentUseUTC.ISO8601"],
                });
                i = i + 1;
            }
        }
    }
    columns = [
        {
            headerName: "Status",
            field: "status",
            minWidth: 100,
            renderCell: (params) =>
                params.value === true ? (
                 <>
                    <div className="active-circle mr-1"></div> Online
                    </>
                ) : (
                 <>
                   <div className="inactive-circle mr-1"></div> Offline
                   </>
                ),
        },
        {
            headerName: "Type",
            field: "type",
            minWidth: 250,
        },
        {
            headerName: "Device Name",
            field: "deviceName",
            minWidth: 250,
        },
        {
            headerName: "Host Name",
            field: "hostName",
            minWidth: 250,
        },
        {
            headerName: "IP Address",
            field: "ipaddress",
            minWidth: 150,
        },
        {
            headerName: "Last Connected",
            field: "lastConnected",
            type: "date",
            valueFormatter: (value) =>
                value &&
                new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                }).format(new Date(value)),
            minWidth: 150,
        },
    ];
    rows = userAttributes;
    return (
        <div style={{ height: 400, width: "100%" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                getRowHeight={({ id, densityFactor }) => {
                    return 60 * densityFactor;
                }}
                slots={{ toolbar: QuickSearchToolbar }}
            />
        </div>
    );
}
